import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CopyIcon, CheckIcon } from 'lucide-react';
interface CodeBlockProps {
  code: string;
  language?: string;
}
export function CodeBlock({
  code,
  language
}: CodeBlockProps) {
  const [copied, setCopied] = useState(false);
  const handleCopy = () => {
    navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return <motion.div initial={{
    opacity: 0,
    y: 5
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.2
  }} className="relative bg-slate-950 border border-slate-800 rounded-lg overflow-hidden" data-id="element-298">
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-2 bg-slate-900/50 border-b border-slate-800" data-id="element-299">
        <span className="text-xs text-slate-400 font-mono" data-id="element-300">
          {language || 'code'}
        </span>
        <button onClick={handleCopy} className="flex items-center gap-1.5 px-2 py-1 text-xs text-slate-400 hover:text-white bg-slate-800 hover:bg-slate-700 rounded transition-colors" data-id="element-301">
          {copied ? <>
              <CheckIcon className="w-3 h-3" data-id="element-302" />
              Copied
            </> : <>
              <CopyIcon className="w-3 h-3" data-id="element-303" />
              Copy
            </>}
        </button>
      </div>
      {/* Code Content */}
      <pre className="p-4 overflow-x-auto" data-id="element-304">
        <code className="text-xs text-slate-200 font-mono leading-relaxed" data-id="element-305">
          {code}
        </code>
      </pre>
    </motion.div>;
}